/*=====================================
    商品常用變數或method

    Author: Gray
    CreateTime: 2018 / 11 / 16
=====================================*/
window.InifECShared.factory("ProductUtil", [function() {

    /*--------------------------
        Variable
    --------------------------*/

    // 規格商品類型
    var PdtSpecClassType = {
        DELETE: -1, // 刪除
        NORMAL: 0, // 一般
        ACCESSORY: 1, // 配件
    };

    // 商品價格計算規則型態
    var PriceRuleType = {
        DEFAULT_RULE: 0, // 預設規則，價錢寫死在rule
        COUNT_RULE: 1, // 數量規則，會依造數量來決定商品的價格
    };

    // 商品購買型態
    var ProductShoppingType = {
        OLD_REVIEW_PAYMENT_PRINT: 0, // 舊版流程：下單 -> 審核 -> 付款 -> 送印
        DEFAULT_PAYMENT_REVIEW_PRINT: 1, // 一般流程：下單 -> 付款 -> 審核 -> 送印
        DESIGN_PAYMENT_REVIEW_PRINT: 2, // 設計流程：下單 -> 報價 -> 付款 -> 審核 -> 確認 -> 送印
        STOCK_PAYMENT: 3, // 現貨流程：下單 -> 付錢 -> 送貨
        ONLY_TEXT_REVIEW_PAYMENT_PRINT: 4, // 純打字修改服務：下單 -> 文字修改審稿 -> 付款 -> 送印
    };

    // 商品配送類型
    var ProductDeliveryType = {
        DEFAULT: 0, // 預設
        LARGE: 1, // 商品過大，需專車接送
        ONLY_SELF: 2, // 限自取
    };

    // 商品標籤
    var ProductLabel = {
        LABEL_UNDEFINED: 0, // 未定義
        LABEL_NEW: 1, // 最新
        LABEL_RECOMMEND: 2, // 推薦
        LABEL_HOT: 4, // 熱門
        LABEL_FREE_SHIPPING: 8, // 免運
    };

    // 尺寸單位
    var SizeUnit = {
        MILLIMETER: 1, // 公釐
        CENTIMETER: 2, // 公分
        METER: 3, // 公尺
        SQUARE_MILLIMETER: 4, // 平方公釐
        SQUARE_CENTIMETER: 5, // 平方公分
        SQUARE_METER: 6, // 平方公尺
        CUBE_MILLIMETER: 7, // 立方公釐
        CUBE_CENTIMETER: 8, // 立方公分
        CUBE_METER: 9, // 立方公尺
        VOLUME_MILLIMETER: 10, // 毫升
        VOLUME_OUNCE: 11, // 盎司
        MICROMETER: 12, // 微米
    };

    // 設計需求
    var ProductDesignRequirementType = {
        SELF_FILE: 1, // 自備檔案
        ONLY_TEXT: 2, // 純打字服務
    };

    // 衣服尺寸代碼
    var ClothingSizeUnit = {
        XS: 1, // XS
        S: 2, // S
        M: 3, // M
        L: 4, // L
        XL: 5, // XL
        XXL: 6, // 2XL
        XXXL: 7, // 3XL
        X4L: 8, // 4XL
        X5L: 9, // 5XL
        X6L: 10, // 6XL
        N6: 11, // 6號
        N8: 12, // 8號
        N10: 13, // 10號
        N12: 14, // 12號
        CUSTOM: 999, // CUSTOM
    };

    // 印刷方式代碼
    var PdtPrintingType = {
        NO_PRINTING: 1, // 不印刷
        SCREEN_PRINTING: 2, // 網版印刷
    }

    // 商品規格所有欄位
    var PdtSpecProps = {
        Length: "length", // 長
        Width: "width", // 寬
        Height: "height", // 高
        BleedLength: "bleedLength", // 出血長
        BleedWidth: "bleedWidth", // 出血寬
        BleedHeight: "bleedHeight", // 出血高
        SizeRemark: "sizeRemark", // 尺寸備註
        SizeUnit: "sizeUnit", // 尺寸單位
        IsOneSide: "isOneSide", // 是否單面
        IsTwoSide: "isTwoSide", // 是否雙面
        PdtStyle: "pdtStyle", // 樣式
        MaterialType: "materialType", // 材質
        Version: "version", // 版型
        Thickness: "thickness", // 厚度
        ThicknessUnit: "thicknessUnit", // 厚度單位
        AreaRange: "areaRange", // 面積範圍
        Modulus: "modulus", // 模數
        Volume: "volume", // 容量
        Bronzing: "bronzing", // 燙金大小
        Dpi: "dpi", // 解析度
        ImageLength: "imageLength", // 圖面長
        ImageWidth: "imageWidth", // 圖面寬
        ImageBleedLength: "imageBleedLength", // 圖面出血長
        ImageBleedWidth: "imageBleedWidth", // 圖面出血寬
        ImageSizeRemark: "imageSizeRemark", // 印刷尺寸備註
        ImageSizeUnit: "imageSizeUnit", // 印刷尺寸單位
        SleeveLength: "sleeveLength", // 袖長
        ClothingSizeList: "clothingSizeList", // 衣服尺寸(只會是陣列，因為下單也會下多個)
        PrintingAreaList: "printingAreaList", // 印刷範圍(只會是陣列，因為下單也會下多個)
        IsEmergency: "isEmergency", // 是否急件
        PrintingMinCount: "printingMinCount", // 最小印刷數

        // 欄位是多個選項
        DesignRequirementList: "designRequirementList", // 設計需求(多個)
        ColorHexList: "colorHexList", // 顏色(多個)
        PrintingTypeList: "printingTypeList", // 印刷方式(多個)
        PrintingColorCountList: "printingColorCountList", // 印刷顏色數量(多個)
        PrintingPathCountList: "printingPathCountList", // 可印刷幾處(多個)
        RollingColorHexList: "rollingColorHexList", // 滾邊色(多個)

        // 訂單商品的選項（像是從欄位是多個選項中選的一個）
        DesignRequirement: "designRequirement", // 設計需求
        ColorHex: "colorHex", // 顏色
        PrintingType: "printingType", // 印刷方式
        PrintingColorCount: "printingColorCount", // 印刷顏色數量
        PrintingPathCount: "printingPathCount", // 可印刷幾處
        RollingColorHex: "rollingColorHex", // 滾邊色
    };

    // 商品面積範圍資料結構
    var PdtAreaRangeInfo = {
        rangeStart: undefined, // 面積起始
        rangeEnd: undefined,// 面積結束
    };

    // 商品燙金資料結構
    var PdtBronzingInfo = {
        name: undefined, // 燙金名稱
        basicPrice: 0, // 基本價
        miniUnitPrice: 0, // 單價
        platemakingPrice: 0, // 版費
    };
    
    // 商品顏色結構
    var PdtColorInfo = {
        hex: undefined, // hex碼
        subHex: undefined, // 副顏色 hex 碼
        isTranslucent: false, // 是否判透明
        printCodeMap: {}, // 送印代碼表 <供應商id, 送印代碼>
        colorName: '', // 顏色名稱
    };

    // 商品衣服尺寸結構
    var PdtClothingSizeInfo = {
        clothingSizeunit: undefined, // 衣服尺寸代號
        customSizeName: '', // 自訂尺寸名稱
        remark: '', // 該尺寸備註，會顯示在前端
        count: 0, // 購買數量
        extraUnitPrice: 0, // 額外單價
    };

    // 商品印刷範圍結構
    var PdtPrintingAreaInfo = {
        name: undefined, // 該印刷範圍的名稱，例如左胸
        minLength: 1, // 最小長
        maxLength: undefined, // 最大長
        minWidth: 1, // 最小寬
        maxWidth: undefined, // 最大寬
        minHeight: 1, // 最小高
        maxHeight: undefined, // 最大高
        sizeUnit: SizeUnit.CENTIMETER, // @see SizeUnit 預設公分
        // 以下是加入購物車選到的資訊
        length: undefined, // 選到的長
        width: undefined, // 選到的寬
        height: undefined, // 選到的高
    };

    // 印刷顏色數量結構
    var PdtPrintingColorCountInfo = {
        name: undefined,
    };

    // 可印刷幾處的資料
    var PdtPrintingPathCountInfo = {
        pathCount: undefined, // 印幾處
        extraUnitPrice: 0, // 該處的單價
    };

    /*--------------------------
        Method
    --------------------------*/

    // ------------------------------
    // 取得規格商品類型文字
    // ------------------------------
    var getPdtSpecClassTypeText = function(type) {

        switch(type) {
            case PdtSpecClassType.DELETE:
                return "刪除";
            case PdtSpecClassType.NORMAL:
                return "一般";
            case PdtSpecClassType.ACCESSORY:
                return "配件";
            default:
                return "";
        }
    }

    // ------------------------------
    // 取得尺寸單位文字
    // ------------------------------
    function getSizeUnitText(sizeUnit, noSup) {

        switch(sizeUnit) {
            case SizeUnit.MILLIMETER: // mm
                return "mm";
            case SizeUnit.CENTIMETER: // cm
                return "cm";
            case SizeUnit.METER: // m
                return "m";
            case SizeUnit.SQUARE_MILLIMETER: // mm^2
                return noSup ? "mm" : "mm2";
            case SizeUnit.SQUARE_CENTIMETER: // cm^2
                return noSup ? "cm" : "cm2";
            case SizeUnit.SQUARE_METER: // m^2
                return noSup ? "m" : "m2";
            case SizeUnit.CUBE_MILLIMETER: // mm^3
                return noSup ? "mm" : "mm3";
            case SizeUnit.CUBE_CENTIMETER: // cm^3
                return noSup ? "cm" : "cm3";
            case SizeUnit.CUBE_METER: // m^3
                return noSup ? "m" : "m3";
            case SizeUnit.VOLUME_MILLIMETER: // cc
                return "cc";
            case SizeUnit.VOLUME_OUNCE: // oz
                return "oz";
            case SizeUnit.MICROMETER: // um
                return "um";
            default:
                return;
        }
    }

    // ------------------------------
    // 取得尺寸單位html
    // ------------------------------
    function getSizeUnitHtml(sizeUnit) {

        switch(sizeUnit) {
            case SizeUnit.MILLIMETER: // mm
                return "<span>mm</span>";
            case SizeUnit.CENTIMETER: // cm
                return "<span>cm</span>";
            case SizeUnit.METER: // m
                return "<span>m</span>";
            case SizeUnit.SQUARE_MILLIMETER: // mm^2
                return "<span>mm<sup>2</sup></span>";
            case SizeUnit.SQUARE_CENTIMETER: // cm^2
                return "<span>cm<sup>2</sup></span>";
            case SizeUnit.SQUARE_METER: // m^2
                return "<span>m<sup>2</sup></span>";
            case SizeUnit.CUBE_MILLIMETER: // mm^3
                return "<span>mm<sup>3</sup></span>";
            case SizeUnit.CUBE_CENTIMETER: // cm^3
                return "<span>cm<sup>3</sup></span>";
            case SizeUnit.CUBE_METER: // m^3
                return "<span>m<sup>3</sup></span>";
            case SizeUnit.VOLUME_MILLIMETER: // cc
                return "<span>cc</span>";
            case SizeUnit.VOLUME_OUNCE: // oz
                return "<span>oz</span>";
            case SizeUnit.MICROMETER: // um
                return "<span>um</span>";
            default:
                return "";
        }
    }

    // ------------------------------
    // 取得設計需求文字
    // ------------------------------
    var getProductDesignRequirementTypeText = function(type) {

        switch(type) {
            case ProductDesignRequirementType.SELF_FILE:
                return "自備檔案";
            case ProductDesignRequirementType.ONLY_TEXT:
                return "純打字服務";
            default:
                return "";
        }
    }

    // ------------------------------
    // 取得商品配送類型文字
    // ------------------------------
    var getProductDeliveryTypeText = function(type) {

        switch(type) {
            case ProductDeliveryType.DEFAULT:
                return "宅配";
            case ProductDeliveryType.LARGE:
                return "專車配送";
            case ProductDeliveryType.ONLY_SELF:
                return "自取";
            default:
                return "";
        }
    }

    // ------------------------------
    // 取得衣服尺寸代碼文字
    // ------------------------------
    var getClothingSizeUnitText = function(clothingSizeunit) {
        
        switch(clothingSizeunit) {
            case ClothingSizeUnit.XS:
                return  "XS";
            case ClothingSizeUnit.S:
                return  "S";
            case ClothingSizeUnit.M:
                return  "M";
            case ClothingSizeUnit.L:
                return  "L";
            case ClothingSizeUnit.XL:
                return  "XL";
            case ClothingSizeUnit.XXL:
                return  "2XL";
            case ClothingSizeUnit.XXXL:
                return  "3XL";
            case ClothingSizeUnit.X4L:
                return  "4XL";
            case ClothingSizeUnit.X5L:
                return  "5XL";
            case ClothingSizeUnit.X6L:
                return  "6XL";
            case ClothingSizeUnit.N6:
                return  "6號";
            case ClothingSizeUnit.N8:
                return  "8號";
            case ClothingSizeUnit.N10:
                return  "10號";
            case ClothingSizeUnit.N12:
                return  "12號";
            case ClothingSizeUnit.CUSTOM: // 由外部決定顯示什麼字
            default:
                return "";
        }
    }

    // ------------------------------
    // 取得印刷方式代碼文字
    // ------------------------------
    var getPdtPrintingTypeText = function(printingType) {
        
        switch(printingType) {
            case PdtPrintingType.NO_PRINTING:
                return  "不印刷";
            case PdtPrintingType.SCREEN_PRINTING:
                return  "印刷"; // 網版印刷
            default:
                return "";
        }
    }

    var factory = {
        /*--------------------------
            Variable
        --------------------------*/
        PdtSpecClassType: PdtSpecClassType, // 規格商品類型
        PriceRuleType: PriceRuleType, // 商品價格計算規則型態
        ProductShoppingType: ProductShoppingType, // 商品購買型態
        ProductDeliveryType: ProductDeliveryType, // 商品配送類型
        ProductLabel: ProductLabel,// 商品標籤
        SizeUnit: SizeUnit, // 尺寸單位
        ProductDesignRequirementType: ProductDesignRequirementType, // 設計需求
        ClothingSizeUnit: ClothingSizeUnit, // 衣服尺寸代碼
        PdtPrintingType: PdtPrintingType, // 印刷方式代碼
        PdtSpecProps: PdtSpecProps, // 商品規格所有欄位
        PdtAreaRangeInfo: PdtAreaRangeInfo, // 商品面積範圍資料結構
        PdtBronzingInfo: PdtBronzingInfo, // 商品燙金資料結構
        PdtColorInfo: PdtColorInfo, // 商品顏色結構
        PdtClothingSizeInfo: PdtClothingSizeInfo, // 商品衣服尺寸結構
        PdtPrintingAreaInfo: PdtPrintingAreaInfo, // 商品印刷範圍結構
        PdtPrintingColorCountInfo: PdtPrintingColorCountInfo, // 印刷顏色數量結構
        PdtPrintingPathCountInfo: PdtPrintingPathCountInfo, // 可印刷幾處的資料

        /*--------------------------
            Method
        --------------------------*/
        getPdtSpecClassTypeText: getPdtSpecClassTypeText, // 取得規格商品類型文字
        getSizeUnitText: getSizeUnitText, // 取得尺寸單位文字
        getSizeUnitHtml: getSizeUnitHtml, // 取得尺寸單位html
        getProductDesignRequirementTypeText: getProductDesignRequirementTypeText, // 取得設計需求文字
        getProductDeliveryTypeText: getProductDeliveryTypeText, // 取得商品配送類型文字
        getClothingSizeUnitText: getClothingSizeUnitText, // 取得衣服尺寸代碼文字
        getPdtPrintingTypeText: getPdtPrintingTypeText, // 取得印刷方式代碼文字
    };    
    
    return factory;
}]);